import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'kt-profile-avatar',
  templateUrl: './profile-avatar.component.html',
  styleUrls: ['./profile-avatar.component.scss'],
})
export class ProfileAvatarComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';
  @Input() color: 'primary' | 'secondary' | 'tertiary' | 'neutral' = 'neutral';
  @Input() entities: any[];
  @Input() urlPath: string;
  @Input() maxVisible = 1;
  @Input() formatters: { tooltip: (entity: any) => string; fallback: (entity: any) => string };
  @Input() removable = false;
  @Output() removed = new EventEmitter<any>();

  formatHidden(): string {
    const hiddenEntities = this.entities.slice(this.maxVisible);

    if (hiddenEntities.length > 0 && this.formatters.tooltip) {
      return hiddenEntities.map((e) => this.formatters.tooltip(e)).join(', ');
    }

    return '';
  }
  onRemove(entity: any): void {
    this.removed.emit(entity);
  }
  getNested(obj: any): any {
    return this.urlPath.split('.').reduce((o, key) => o?.[key], obj);
  }
}
